import HTTP from "../http";

function createFormData(file) {
  let formData = new FormData();
  formData.append("upload_preset", "clients");
  formData.append("file", file);
  return formData;
}

function isAFileObject(file) {
  return file instanceof File;
}

async function upload(file) {
  try {
    if (!isAFileObject(file)) return;
    let formData = createFormData(file);
    let response = await HTTP.cloudinary.post("/upload", formData);
    return response.data.secure_url;
  } catch (e) {
    throw "Não foi possível fazer o upload da imagem";
  }
}

export default { upload };



// WEBPACK FOOTER //
// ./src/api/modules/cloudinary.js